/* Copyright (C) Okahu Inc 2023-2024. All rights reserved.*/

import React, { Dispatch, SetStateAction } from 'react';
import { IPrompt } from 'types/prompt';

import { CustomButton } from '../common';
import { System } from '../icons';

export const PromptPagination = ({
  currentPage,
  setCurrentPage,
  totalPages,
  promptList,
  itemsPerPage,
  selectedFact,
}: {
  currentPage: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
  totalPages: number;
  promptList: IPrompt[] | object;
  itemsPerPage: number;
  selectedFact: string;
}) => {
  const isListEmpty =
    (Array.isArray(promptList) && promptList.length === 0) ||
    (typeof promptList === 'object' &&
      promptList !== null &&
      Object.keys(promptList).length === 0);

  const isPreviousDisabled = currentPage === 1 || isListEmpty;
  const isNextDisabled = currentPage === totalPages || isListEmpty;

  let itemCountText = '0 of 0';

  if (!isListEmpty) {
    if (Array.isArray(promptList)) {
      const totalItems = promptList.length;
      const startItem = (currentPage - 1) * itemsPerPage + 1;
      const endItem = Math.min(currentPage * itemsPerPage, totalItems);
      itemCountText =
        selectedFact === 'inferences'
          ? `${startItem}-${endItem} of ${totalItems}`
          : `${startItem} of ${totalItems}`;
    } else if (
      typeof promptList === 'object' &&
      Object.keys(promptList).length > 0
    ) {
      const totalGroups = Object.keys(promptList).length;
      const startGroup = (currentPage - 1) * itemsPerPage + 1;
      const endGroup = Math.min(currentPage * itemsPerPage, totalGroups);
      itemCountText =
        selectedFact === 'inferences'
          ? `${startGroup}-${endGroup} of ${totalGroups}`
          : `${startGroup} of ${totalGroups}`;
    }
  }

  return (
    <div className="flex items-center justify-end gap-2">
      {!isListEmpty && (
        <span className="mr-2 text-form-input-text font-medium text-form-input-disabled">
          {itemCountText}
        </span>
      )}
      <CustomButton
        customSize="regular"
        customVariant="secondary"
        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
        disabled={isPreviousDisabled}
        className="border-none p-0 hover:bg-transparent active:bg-transparent"
      >
        {System.ChevronLeftIcon('size-6 text-[#C1C9CF]')}
      </CustomButton>

      <CustomButton
        customSize="regular"
        customVariant="secondary"
        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
        disabled={isNextDisabled}
        className="border-none p-0 hover:bg-transparent active:bg-transparent"
      >
        {System.ChevronRightIcon('size-6 text-[#C1C9CF]')}
      </CustomButton>
    </div>
  );
};
